<template>
    <transition name="fade">
        <div
            v-if="visible"
            :class="[
                'visual-tooltip',
                tooltip.modify,
                {'visual-tooltip_size_small': tooltip.isSold},
                `is-${direction}`]"
            :style="[{'top': `${y}px`}, {'left': `${x}px`}]"
            ref="wrapper">
            <template v-if="dataStep.step !== 'flat'">
                <div class="visual-tooltip__header">
                    <div class="visual-tooltip__title h5" v-html="tooltip.title"></div>
                    <div v-if="tooltip.comment && tooltip.price && $dataset.propertyType === 'commerce'"
                         class="visual-tooltip__comment">
                        <span class="accent" v-html="tooltip.comment"></span>
                        <span class="accent" v-html="`от&nbsp;${convertPriceRank(tooltip.price)}&nbsp;млн`"></span>
                    </div>

                    <div v-else-if="tooltip.comment"
                         class="visual-tooltip__comment accent"
                         v-html="tooltip.comment"></div>
                </div>

                <ul class="visual-tooltip__params">
                    <li
                        v-for="(item, index) in tooltip.params"
                        v-if="!item.disabled"
                        :key="index"
                        class="visual-tooltip__params-item">

                        <div v-if="item.flats" class="visual-tooltip__sign" v-html="item.flats"></div>
                        <div v-if="item.amount" class="visual-tooltip__amount" v-html="item.amount"></div>

                        <div v-if="item.price && dataStep.step !== 'flat' && !item.requirePrice"
                            class="visual-tooltip__value">
                            <template v-if="$dataset.propertyType === 'parking'">
                                от {{ convertPriceRankParking(item.price) }} тыс
                            </template>
                            <template v-else>
                                от {{ convertPriceRank(item.price) }} млн
                            </template>
                        </div>
                        <div v-if="item.price && dataStep.step !== 'flat' && item.requirePrice"
                             class="visual-tooltip__value">
                            Цена по запросу
                        </div>

                        <div v-if="item.price && dataStep.step === 'flat' && !item.requirePrice"
                            class="visual-tooltip__value">
                                {{ convertPriceDigit(item.price) }} руб
                        </div>
                        <div v-if="item.price && dataStep.step === 'flat' && item.requirePrice"
                             class="visual-tooltip__value">
                            Цена по запросу
                        </div>
                    </li>
                </ul>
            </template>

            <!-- Данные планировок -->
            <template v-else>
                <div class="visual-tooltip__header">
                    <div class="visual-tooltip__title h5" v-html="tooltip.title"></div>

                    <div v-if="tooltip.isBooked && !tooltip.isSold" class="visual-tooltip__booked">
                        <iconLock className="visual-tooltip__booked-icon"/>
                        Поставлен резерв
                    </div>
                </div>
                <div v-if="!tooltip.isSold" class="visual-tooltip__properties">
                    <div v-if="tooltip.type" class="visual-tooltip__property">
                        <div class="visual-tooltip__property-name">Тип</div>
                        <div class="visual-tooltip__property-value" v-html="tooltip.type"></div>
                    </div>
                    <div v-if="tooltip.area" class="visual-tooltip__property">
                        <div class="visual-tooltip__property-name">Площадь</div>
                        <div class="visual-tooltip__property-value">{{ tooltip.area }} м²</div>
                    </div>
                    <div v-if="tooltip.size" class="visual-tooltip__property">
                        <div class="visual-tooltip__property-value accent">{{ tooltip.size }}</div>
                    </div>

                    <div v-if="tooltip.price" class="visual-tooltip__property">
                        <div v-if="isNumber(tooltip.price)" class="visual-tooltip__price-comment">
                            Цена при 100% оплате
                        </div>
                        <div class="visual-tooltip__price accent">
                            {{ isNumber(tooltip.price) ? `${convertPriceDigit(tooltip.price)} ₽` : tooltip.price }}
                        </div>
                    </div>
                    <div class="visual-tooltip__add-pay" v-if="tooltip.add_pay && $dataset.propertyType === 'parking'">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8.5" r="7" fill="#B98F4F" stroke="#B98F4F"/>
                            <path d="M8.84809 10.64H7.15309L7.00309 2.75H8.99809L8.84809 10.64ZM9.02809 14H6.97309V11.945H9.02809V14Z" fill="white"/>
                        </svg>
                        <span>{{tooltip.add_pay}}</span>
                    </div>
                </div>
            </template>
        </div>
    </transition>
</template>

<style lang='scss'>
    @import "./Tooltip.scss";
</style>

<script>
import iconLock from '../Icons/icon-lock';
import {mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

export default {
    data() {
        return {
            visible  : false,
            tooltip  : false,
            direction: false,
            x        : 0,
            y        : 0
        };
    },

    components: {
        iconLock
    },

    computed: {
        ...mapGetters({
            dataStep: 'GET_DATA_STEP'
        })
    },

    watch: {
        tooltip() {
            this.$nextTick(() => {
                this.wrapper = this.$refs.wrapper;

                this.checkBorders();
                this.setX();
                this.setY();
            });
        }
    },

    mounted() {
        observer.subscribe('mouseoverTooltip', (data) => {
            this.insert(data);
        });

        observer.subscribe('mousemoveTooltip', (event) => {
            this.change(event);
        });

        observer.subscribe('mouseleaveTooltip', () => {
            this.remove();
        });

        observer.subscribe('mouseClickTooltip', () => {
            this.remove();
        });
    },

    methods: {
        insert(data) {
            this.direction = data.direction || 'over';
            this.offset = 40;

            this.getMouseCoords(data.event);
            this.setData(data);

            this.visible = true;
        },

        change(event) {
            this.getMouseCoords(event);
            this.checkBorders();
            this.setX();
            this.setY();
        },

        remove() {
            this.visible = false;
        },

        getMouseCoords(event) {
            this.mouseCoords = {
                X: event.pageX,
                Y: event.pageY
            };
        },

        setData(data) {
            const targetId = Number(data.id);

            const currentData = data.elements.find((element) => {
                const id = Number(element.id);

                return id === targetId ? element : false;
            });

            this.tooltip = {
                type  : data.type,
                modify: data.modify,
                isSold: currentData.isSold,
                ...currentData.tooltip
            };
        },

        checkBorders() {
            const halfWidth = 2;

            let mouseCoord = 0;
            let tooltipCoord = 0;

            // Не влезает по верхнему краю.
            const top = () => {
                mouseCoord = this.mouseCoords.Y;
                tooltipCoord = this.wrapper.offsetHeight + this.offset;

                return mouseCoord < tooltipCoord;
            };

            // Не влезает по правому краю.
            const right = () => {
                mouseCoord = window.innerWidth - this.mouseCoords.X;
                tooltipCoord = (this.wrapper.offsetWidth / halfWidth) + this.offset;

                return mouseCoord < tooltipCoord;
            };

            // Не влезает по левому краю.
            const left = () => {
                mouseCoord = this.mouseCoords.X;
                tooltipCoord = (this.wrapper.offsetWidth / halfWidth) - this.offset;

                return mouseCoord < tooltipCoord;
            };

            if (top()) {
                this.direction = 'under';
            }

            if (right()) {
                this.direction = 'left';
            }

            if (left()) {
                this.direction = 'right';
            }
        },

        setX() {
            const halfWidth = 2;

            switch (this.direction) {
                case 'over':
                    this.x = this.mouseCoords.X - (this.wrapper.offsetWidth / halfWidth);
                    break;
                case 'under':
                    this.x = this.mouseCoords.X - (this.wrapper.offsetWidth / halfWidth);
                    break;
                case 'left':
                    this.x = this.mouseCoords.X - this.wrapper.offsetWidth - this.offset;
                    break;
                case 'right':
                    this.x = this.mouseCoords.X + this.offset;
                    break;
                default:
                    this.x = this.mouseCoords.X - (this.wrapper.offsetWidth / halfWidth);
                    break;
            }
        },

        setY() {
            const halfHeight = 2;

            switch (this.direction) {
                case 'over':
                    this.y = this.mouseCoords.Y - this.wrapper.offsetHeight - this.offset;
                    break;
                case 'under':
                    this.y = this.mouseCoords.Y + this.offset;
                    break;
                case 'left':
                    this.y = this.mouseCoords.Y - (this.wrapper.offsetHeight / halfHeight);
                    break;
                case 'right':
                    this.y = this.mouseCoords.Y - (this.wrapper.offsetHeight / halfHeight);
                    break;
                default:
                    this.y = this.mouseCoords.Y - this.wrapper.offsetHeight - this.offset;
                    break;
            }
        },

        convertPriceRank(price) {
            return Utils.convertToDigit(Utils.convertToRank(price, 1000000).toFixed(2));
        },

        convertPriceRankParking(price) {
            return Utils.convertToDigit(Utils.convertToRank(price, 1000).toFixed(2));
        },

        convertPriceDigit(price) {
            return Utils.convertToDigit(price);
        },

        isNumber(value) {
            return !isNaN(Number(value));
        }
    }
};
</script>
